// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__TIwel","icon":"Sidebar_icon__kWiRl","activeNav":"Sidebar_activeNav__egSka"};